export const customersFr = {
    title: 'Clients',
    list: 'Liste des clients',
    detail: 'Détail du client',
    create: 'Créer un client',
    delete: 'Supprimer le client',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce client ?',
    columns: {
        id: 'ID',
        customerId: 'N° client',
        name: 'Nom',
        ordersCount: 'Commandes',
        actions: 'Actions'
    },
    model: {
        customerId: 'N° client',
        name: 'Nom'
    },
    orders: {
        title: 'Commandes associées',
        orderId: 'N° commande',
        name: 'Nom',
        state: 'État',
        requestedDeliveryDate: 'Date de livraison demandée',
        createdAt: 'Créé le'
    },
    errors: {
        fetchFailed: 'Impossible de charger les clients',
        createFailed: 'Impossible de créer le client',
        updateFailed: 'Impossible de mettre à jour le client',
        deleteFailed: 'Impossible de supprimer le client'
    },
    success: {
        created: 'Client créé avec succès',
        deleted: 'Client supprimé avec succès',
        updated: 'Client mis à jour avec succès'
    },
    table: {
        actions: {
            deleteTitle: 'Supprimer le client',
            deleteContent:
                'Êtes-vous sûr(e) de vouloir supprimer le client ? Cette action est irréversible.'
        }
    }
}
